import ZoomInRoundedIcon from "@mui/icons-material/ZoomInRounded";
import ZoomOutRoundedIcon from "@mui/icons-material/ZoomOutRounded";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const MASS_CHART_ZOOM_FACTORS = [1, 1.5, 2] as const;
export const DEFAULT_MASS_CHART_ZOOM_INDEX = MASS_CHART_ZOOM_FACTORS.indexOf(1);

type MassChartZoomControlsProps = Readonly<{
  zoomIndex: number;
  onZoomIndexChange: (zoomIndex: number) => void;
}>;

export const MassChartZoomControls = ({
  zoomIndex,
  onZoomIndexChange,
}: MassChartZoomControlsProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Tooltip title={t("zoomOut")}>
        <span>
          <IconButton
            size="small"
            aria-label={t("zoomOut")}
            disabled={zoomIndex >= MASS_CHART_ZOOM_FACTORS.length - 1}
            onClick={() => {
              onZoomIndexChange(zoomIndex + 1);
            }}
          >
            <ZoomOutRoundedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={t("zoomIn")}>
        <span>
          <IconButton
            size="small"
            aria-label={t("zoomIn")}
            disabled={zoomIndex <= 0}
            onClick={() => {
              onZoomIndexChange(zoomIndex - 1);
            }}
          >
            <ZoomInRoundedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
